"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteTmp = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const lab_1 = require("@material-ui/lab");
const core_1 = require("@material-ui/core");
const use_debounce_1 = require("use-debounce");
const fast_memoize_1 = __importDefault(require("fast-memoize"));
const utility_1 = require("../../../utility");
const withValidate_1 = __importDefault(require("../../Form/withValidate"));
const prop_types_1 = __importDefault(require("prop-types"));
const ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
const AutocompleteComponent = (props) => {
    const { id, name, options, multiple, freeWriting, disabled, setValidate, validate, variant = 'outlined', caption, placeholder, captionActive, autoFocus = false, readOnly, required, fullWidth = true, className, disableUnderline = false, onChange, onRef, onKeyPress, onKeyDown, onKeyUp, validateMessages, closeOnSelect, groupPath, group, loading, open, onOpen, onClose, closeIcon, popupIcon, onPagination, onSearch, helperText, noOptionsDataText, loadingText, errorText, clearText, closeText, openText, allSelect = { value: false, textField: 'All', valueField: '-1' }, searchText, } = props;
    const { data, selected, displayValue, displayField, scroll = false, search = false, checkBox } = options;
    const input = react_1.useRef();
    react_1.useEffect(() => {
        onRef && onRef(input);
    });
    const [inputValue, setValue] = react_1.useState([]);
    const [optionsData, setOptionsData] = react_1.useState([]);
    const [fieldId, setFieldId] = react_1.useState(id);
    const [searchTextState, setSearchText] = react_1.useState(searchText);
    const [allSelectOption, setAllSelectedOption] = react_1.useState(false);
    const setValidateData = fast_memoize_1.default((value) => {
        data && onChange && onChange(utility_1.getTargetSelectValue(id, name, inputValue, inputValue));
        fieldId && !disabled && validate && setValidate && setValidate(fieldId, value, validate, errorText);
    });
    const setPagination = (val) => {
        onPagination && onPagination(val);
    };
    const setSearch = (e) => {
        if (search) {
            onSearch && onSearch(e);
        }
    };
    const checkPagination = (event) => {
        const promise = new Promise(resolve => {
            if (scroll) {
                const x = Math.ceil(event.target.scrollHeight - event.target.scrollTop);
                const y = event.target.clientHeight;
                if (x === y) {
                    event.target.scrollTop -= 10;
                    resolve(true);
                }
            }
        });
        return promise;
    };
    const [debounceFunc] = use_debounce_1.useDebouncedCallback((value) => setValidateData(value), 250);
    const [debounceFuncScroll] = use_debounce_1.useDebouncedCallback((value) => setPagination(value), 250);
    const [debounceFuncSearch] = use_debounce_1.useDebouncedCallback((value) => setSearch(value), 250);
    react_1.useEffect(() => {
        setAllSelectedOption(allSelect.value);
    }, [allSelect, setAllSelectedOption]);
    react_1.useEffect(() => {
        if (data.length) {
            debounceFunc(inputValue);
        }
    }, [inputValue, debounceFunc, disabled, data]);
    react_1.useEffect(() => {
        if (data.length) {
            setValue(selected);
        }
    }, [selected, setValue, data]);
    react_1.useEffect(() => {
        debounceFuncSearch(searchTextState);
    }, [searchTextState, debounceFuncSearch]);
    react_1.useEffect(() => {
        let dataGroup = [];
        let sortData = [];
        if (groupPath) {
            dataGroup =
                data && data.length
                    ? data.map((option) => {
                        const firstLetter = groupPath
                            ? lodash_1.get(option, groupPath || '')
                            : option[displayField][0].toUpperCase();
                        return Object.assign({ firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter }, option);
                    })
                    : [];
            sortData = dataGroup.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter));
        }
        const newData = {
            [displayValue]: allSelect.valueField,
            [displayField]: allSelect.textField,
        };
        const dataWithAllSelectOptions = groupPath ? [newData].concat(sortData) : [newData].concat(data);
        if (lodash_1.isArray(inputValue) && inputValue.length) {
            const checkAllSelect = inputValue.some((e) => e[displayValue] === allSelect.valueField);
            if (checkAllSelect) {
                setValue(dataWithAllSelectOptions);
            }
        }
        allSelectOption
            ? setOptionsData(dataWithAllSelectOptions)
            : groupPath
                ? setOptionsData(sortData)
                : setOptionsData(data);
    }, [data, displayField, groupPath, allSelectOption, displayValue, allSelect, inputValue]);
    const handleChange = (e, val) => {
        if (val !== null && val.length && val.length > inputValue.length) {
            const pop = val[val.length - 1];
            if (lodash_1.isArray(inputValue) && inputValue.length) {
                const check = inputValue.some((e) => e[displayValue] === pop[displayValue]);
                const filterd = inputValue.filter((e) => e[displayValue] !== pop[displayValue]);
                return check ? setValue(filterd) : setValue(val);
            }
        }
        if (val === null) {
            setValue(multiple ? [] : '');
        }
        else {
            setValue(val);
        }
    };
    const searchHandle = (e) => {
        setSearchText(e.target.value);
    };
    const handleScroll = (event) => {
        return checkPagination(event).then(res => {
            if (res) {
                debounceFuncScroll(res);
            }
        });
    };
    const checkSelected = (option) => {
        return inputValue.length && checkBox
            ? inputValue.some((e) => e[displayValue] === option[displayValue])
            : false;
    };
    const checkBoxChange = (option) => {
        if (option[displayValue] === allSelect.valueField) {
            const checkAll = inputValue.some((e) => e[displayValue] === allSelect.valueField);
            if (checkAll) {
                setValue([]);
            }
            else {
                setValue(optionsData);
            }
        }
    };
    return (react_1.default.createElement(lab_1.Autocomplete, Object.assign({ multiple: multiple || false, freeSolo: freeWriting, options: optionsData }, (group
        ? {
            groupBy: (option) => groupPath ? lodash_1.get(option, groupPath || '') : option[displayField][0].toUpperCase(),
        }
        : {}), { value: inputValue, clearOnEscape: false, disableCloseOnSelect: closeOnSelect, getOptionLabel: (option) => (option && option[displayField]) || (!multiple ? inputValue : ''), renderTags: (value, getTagProps) => value.map((option, index) => (react_1.default.createElement(core_1.Chip, Object.assign({ label: option[displayField] }, getTagProps({ index }), { key: index })))), open: open, onOpen: () => onOpen && onOpen(), onClose: () => onClose && onClose(), className: "oneframe-form-field oneframe-form-autocomplete", noOptionsText: noOptionsDataText, loadingText: loadingText, clearText: clearText, closeText: closeText, openText: openText, disabled: disabled, closeIcon: closeIcon, popupIcon: popupIcon, filterSelectedOptions: false, onInputChange: (_, val) => {
            if (val && freeWriting && !multiple) {
                setValue(val);
            }
        }, ListboxProps: {
            onScroll: handleScroll,
        }, renderOption: (option, state) => {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                checkBox ? (react_1.default.createElement(core_1.Checkbox, { checked: checkSelected(option), tabIndex: -1, disableRipple: true, inputProps: { 'aria-labelledby': option }, onChange: e => checkBoxChange(option) })) : null,
                react_1.default.createElement(ListItemText_1.default, { id: option, primary: option[displayField], onClick: e => {
                        setTimeout(() => {
                            checkBoxChange(option);
                        }, 200);
                    } })));
        }, renderInput: (params) => {
            setFieldId(params.id);
            return (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { inputProps: Object.assign(Object.assign({}, params.inputProps), { className: params.inputProps.className + ' oneframe-input' }), InputProps: Object.assign(Object.assign(Object.assign(Object.assign({}, params.InputProps), { className: `${params.InputProps.className} oneframe-input-base oneframe-input-autocomplete ${multiple ? 'oneframe-input-multiple' : 'oneframe-input-single'} `, readOnly }), (variant === 'filled' ? { disableUnderline } : {})), { endAdornment: (react_1.default.createElement(react_1.default.Fragment, null,
                        loading ? react_1.default.createElement(core_1.CircularProgress, { color: "inherit", size: 20 }) : null,
                        params.InputProps.endAdornment)) }), InputLabelProps: Object.assign(Object.assign({}, params.InputLabelProps), (Object.prototype.hasOwnProperty.call(props, 'captionActive') && captionActive ? { shrink: true } : {})), label: caption, variant: variant, placeholder: placeholder, className: className, fullWidth: fullWidth, spellCheck: false, required: required, autoFocus: autoFocus, disabled: disabled, error: utility_1.getErrorStatus(validateMessages, fieldId, errorText), helperText: utility_1.getErrorMessage(validateMessages, fieldId, errorText, helperText), onKeyPress: (e) => {
                    e.key === 'Enter' && e.preventDefault();
                    onKeyPress && onKeyPress(e);
                }, onKeyDown: (e) => {
                    e.key === 'Enter' && e.preventDefault();
                    onKeyDown && onKeyDown(e);
                }, onKeyUp: (e) => {
                    e.key === 'Enter' && e.preventDefault();
                    onKeyUp && onKeyUp(e);
                }, onChange: e => searchHandle(e) })));
        }, ref: input, onChange: (e, val) => handleChange(e, val) })));
};
AutocompleteComponent.propTypes = {
    id: prop_types_1.default.string.isRequired,
    name: prop_types_1.default.string.isRequired,
    className: prop_types_1.default.string,
    caption: prop_types_1.default.string,
    errorText: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    helperText: prop_types_1.default.string,
    noOptionsDataText: prop_types_1.default.string,
    groupPath: prop_types_1.default.string,
    captionActive: prop_types_1.default.bool,
    readOnly: prop_types_1.default.bool,
    disableUnderline: prop_types_1.default.bool,
    submitStatus: prop_types_1.default.bool,
    autoFocus: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    required: prop_types_1.default.bool,
    fullWidth: prop_types_1.default.bool,
    multiple: prop_types_1.default.bool,
    closeOnSelect: prop_types_1.default.bool,
    freeWriting: prop_types_1.default.bool,
    loading: prop_types_1.default.bool,
    group: prop_types_1.default.bool,
    variant: prop_types_1.default.oneOf(['standard', 'outlined', 'filled']),
    onRef: prop_types_1.default.func,
    onChange: prop_types_1.default.func,
    onKeyPress: prop_types_1.default.func,
    onKeyDown: prop_types_1.default.func,
    onKeyUp: prop_types_1.default.func,
    validate: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        required: prop_types_1.default.oneOf([
            'required',
            'maxSelect',
            'minSelect',
            'min',
            'max',
            'maxLength',
            'minLength',
            'custom',
            'email',
            'pattern',
            'url',
            'creditcard',
            'number',
        ]),
        message: prop_types_1.default.string.isRequired,
        regex: prop_types_1.default.any,
        validate: prop_types_1.default.oneOfType([prop_types_1.default.func, prop_types_1.default.bool]),
        value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    })),
    setValidate: prop_types_1.default.any,
    validateMessages: prop_types_1.default.any,
    ref: prop_types_1.default.any,
    error: prop_types_1.default.any,
    closeIcon: prop_types_1.default.node,
    popupIcon: prop_types_1.default.node,
    loadingText: prop_types_1.default.node,
    options: prop_types_1.default.shape({
        data: prop_types_1.default.arrayOf(prop_types_1.default.any).isRequired,
        displayValue: prop_types_1.default.string.isRequired,
        displayField: prop_types_1.default.string.isRequired,
        selected: prop_types_1.default.any,
        disabled: prop_types_1.default.any,
        search: prop_types_1.default.bool,
        scroll: prop_types_1.default.bool,
        checkBox: prop_types_1.default.bool,
    }),
};
exports.AutocompleteTmp = AutocompleteComponent;
const MemoComponent = react_1.default.memo(AutocompleteComponent, (p, n) => lodash_1.isEqual(p.options, n.options) &&
    lodash_1.isEqual(p.validateMessages, n.validateMessages) &&
    lodash_1.isEqual(p.disabled, n.disabled) &&
    lodash_1.isEqual(p.loading, n.loading) &&
    lodash_1.isEqual(p.caption, n.caption));
exports.default = withValidate_1.default(MemoComponent);
